import { lazy } from 'react';

export const AuthSignUpScreenLazy = lazy(async () => {
  const { AuthSignUpScreen } = await import('./auth-sign-up.screen.tsx');
  return { default: AuthSignUpScreen };
});
